import React from "react";
import { Grid, Typography, Box, TextField, MenuItem } from "@mui/material";
import { Controller } from "react-hook-form";
import { isMobile } from "react-device-detect";
import ClearanceCertificateTable from "./ClearanceCertificateTable";

const ClearanceCertificateForm = ({
  control,
  errors,
  services,
  externalEntities,
}) => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          الخدمات المسجلة
        </Typography>
      </Box>
      <Grid
        sx={{ background: "#fff", p: 2, mt: 1, width: "100%" }}
        spacing={4}
        container
      >
        <Grid item xs={12} md={9}>
          <Controller
            name="selectedService"
            control={control}
            rules={{
              required: false,
            }}
            render={({ field }) => (
              <>
                <ClearanceCertificateTable data={services} />
              </>
            )}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ fontWeight: "bold" }}>جهات خارجية</Typography>

          <Controller
            name="externalEntities"
            control={control}
            defaultValue=""
            rules={{
              required: "هذا الحقل مطلوب",
            }}
            render={({ field }) => (
              <TextField
                {...field}
                select
                fullWidth
                variant="outlined"
                InputProps={{
                  placeholder: "",
                }}
                FormHelperTextProps={{
                  sx: {
                    textAlign: "start",
                  },
                }}
                error={!!errors.externalEntities}
                helperText={
                  errors.externalEntities ? errors.externalEntities.message : ""
                }
              >
                {externalEntities.map((option) => (
                  <MenuItem key={option.name} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ClearanceCertificateForm;
